(function () {
  var PRODUCT_SELECTOR = 'product-info[data-url="/products/tally-stickers"], product-info[data-product-id="9151229427943"]';
  var CARD_SELECTOR = '#tdtf-root > div > div, .tdtf-card';
  var retryTimer = null;

  function getProductInfo() {
    return document.querySelector(PRODUCT_SELECTOR);
  }

  function getCard(productInfo) {
    var host = productInfo && productInfo.querySelector('#tally-shadow-host');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector(CARD_SELECTOR);
  }

  function syncHeight(productInfo) {
    var card = getCard(productInfo);
    if (!card) return false;

    var height = Math.ceil(card.getBoundingClientRect().height);
    if (height < 220) return false;

    productInfo.style.setProperty('--tally-sticker-builder-card-height', height + 'px');
    productInfo.classList.add('tally-sticker-builder-height-ready');
    return true;
  }

  function scheduleSync(productInfo) {
    window.requestAnimationFrame(function () {
      syncHeight(productInfo);
    });
  }

  function init() {
    var productInfo = getProductInfo();
    if (!productInfo) return;

    if (!syncHeight(productInfo)) {
      clearTimeout(retryTimer);
      retryTimer = setTimeout(init, 250);
      return;
    }

    var card = getCard(productInfo);
    if (window.ResizeObserver && card) {
      var observer = new ResizeObserver(function () {
        scheduleSync(productInfo);
      });
      observer.observe(card);
    }

    window.addEventListener('resize', function () {
      scheduleSync(productInfo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
